// extracted by mini-css-extract-plugin
export default {"companyContainer":"incident_companyContainer__Tx0r0","titleHead":"incident_titleHead__N6xB8"};